import React from "react";

import "./style.scss";

export const CancellationPolicyText = () => {
	return (
		<div className="big-text">
			<h1>Canellation policy</h1>
			<h2>Profile Deletion</h2>
			<p>
				The user may at any time to delete his /her profile by using the Delete Profile function. Upon deletion of the
				profile all of the personal data of the user, content of the mailbox, information about funds on the User’s
				e-wallet and active subscriptions will be deleted from the system.
			</p>
			<h2>Disqualification</h2>
			<p>
				In case of gross non-compliance with the Terms and Conditions for the Use of the Platform by a player, his /her
				profile might be deleted in a compulsory manner by the Platform Administrator. Where the profile is deleted in a
				compulsory manner, the participation of the Player in all tournaments, where he /she has been registered for,
				shall be automatically canceled net of all fines anticipated by the tournament rules.
				<br />
				Within 30 days the Player shall be refunded the balance of monies in the e-wallet of the Payment System, net of
				all deductions for the cancellation of participation in tournaments and other payments outstanding as of the
				time of disqualification of the Player
			</p>
			<h2>Unsubscribing</h2>
			<p>
				The user may at any time opt-out of active ONE MONTH Subscription without assigning any reasons, by using the
				Unsubscribing function on the User Account page.
				<br />
				No opt-out of ONE DAY Subscription is possible.
				<br />
				Upon refusal of the Service, the funds shall be repaid to the User’s e-wallet pro rata to the number of unused
				full days according to the following formula: R=(M-D)*(T/M)
			</p>
			<h2>where</h2>
			<p>
				R – Funds repayable to the User
				<br /> T – Tariff
				<br /> M – Total number of days in a current month
				<br /> D – number of days in a current month till the moment of refusal of the Service
				<br />
				<br /> The access to the Platform functionality shall be blocked at the time of unsubscribing. In case of
				cessation of Service the Subscription can be recovered in the User Account of the user without re-registration.
			</p>
		</div>
	);
};
